import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

const MdxMdxTable: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box as="div" overflow="auto">
      <table>{children}</table>
    </Box>
  );
};

MdxMdxTable.displayName = 'MdxTable';

const MdxMdxTableHead: FC<PropsWithChildren> = ({ children }) => {
  return <thead>{children}</thead>;
};

MdxMdxTableHead.displayName = 'MdxTableHead';

const MdxMdxTableRow: FC<PropsWithChildren> = ({ children }) => {
  return <tr>{children}</tr>;
};

MdxMdxTableRow.displayName = 'MdxTableRow';

const MdxMdxTableHeader: FC<PropsWithChildren> = ({ children }) => {
  return <th>{children}</th>;
};

MdxMdxTableHeader.displayName = 'MdxTableHeader';

const MdxMdxTableData: FC<PropsWithChildren> = ({ children }) => {
  return <td>{children}</td>;
};

MdxMdxTableData.displayName = 'MdxTableData';

export {
  MdxMdxTable,
  MdxMdxTableHead,
  MdxMdxTableRow,
  MdxMdxTableHeader,
  MdxMdxTableData,
};
